Lyte.Component.register("lyte-notice", {
	data : function(){
		return {
			'ltPropNoticeType' : Lyte.attr('string')
		}		
	},
	actions : {
		// Functions for event handling
	},
	methods : {
		// Functions which can be used as callback in the component.
	}
});
